import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=0b692e4c&scoped=true&"
import script from "./PrivacyConsent.vue?vue&type=script&lang=js&"
export * from "./PrivacyConsent.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=0b692e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b692e4c",
  null
  
)

export default component.exports